import React from 'react';
import './index.scss';
export default function App() {
    const seeds = [
        { num: 1, name: 'Big Top Bitter Melon' },
        { num: 2, name: 'Aji Charapita' },
        { num: 3, name: 'Habanada' },
        { num: 4, name: 'Sugar Rush Peach Pepper' },
        { num: 5, name: 'Orange Hat Tomato' },
        { num: 6, name: 'Litchi Tomato' },
        { num: 7, name: 'Korean Dark Green Pepper' },
        { num: 8, name: 'China Jade Cucumber' },
        { num: 10, name: 'Hedou Tiny Bok Choy' },
        { num: 11, name: 'Dar Cucumber' },
        { num: 12, name: 'Black Strawberry Tomato' },
        { num: 13, name: 'Diamond Eggplant' },
        { num: 14, name: 'Purple Tomatillo' },
        { num: 15, name: 'Spoon Tomato' },
    ];
    return (
        <div className="container">
            <div className="body">
                <div>
                    <h1>Farhan's Seed Catalog</h1>
                    <p>
                        These are pictures and seed numbers for the seeds I bought. Use this page as
                        a reference for whichever seed you get from me!
                    </p>
                </div>
                {seeds.map(({ num, name }) => {
                    return (
                        <div className="seed-con">
                            <h2>{`[${num}] ${name}`}</h2>
                            <div className="seed-image">
                                <img src={`media/seeds/${num}f.jpg`} alt={name} />
                                <img src={`media/seeds/${num}b.jpg`} alt={name} />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
